import ManifestScreen from './index';
import ReceiveScreen from './receive';

const routes = [
  {
    path: '/job-order',
    component: ManifestScreen,
    action: ['read_only', 'manage'],
    service: ['nvo.tms.job'],
  },
  {
    path: '/job-order/receiving',
    component: ReceiveScreen,
    action: ['read_only', 'manage'],
    service: ['nvo.tms.job'],
  },
];

export default routes;
